import { Action } from '../actions/preferences';

const defaultState = {
  isSavingSubscriptions: false,
  isFetchingSubscriptions: false,
  hasError: false,
  subscriptions: undefined,
};

export default function preferencesReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Preferences.UpdateEmailSubscriptionsPending:
      return {
        ...state,
        isSavingSubscriptions: true,
        isFetchingSubscriptions: true,
        hasError: false,
      };

    case Action.Preferences.UpdateEmailSubscriptionsFailed:
      return {
        ...state,
        isSavingSubscriptions: false,
        isFetchingSubscriptions: false,
        subscriptions: body.response?.subscriptions || {},
        hasError: true,
      };

    case Action.Preferences.UpdateEmailSubscriptionsCompleted:
      return {
        ...state,
        isSavingSubscriptions: false,
        isFetchingSubscriptions: false,
        subscriptions: body.subscriptions || {},
        hasError: !!(body.code && body.code >= 400),
      };

    case Action.Preferences.FetchEmailSubscriptionsPending:
      return {
        ...state,
        isFetchingSubscriptions: true,
        hasError: false,
      };

    case Action.Preferences.FetchEmailSubscriptionsFailed:
      return {
        ...state,
        isFetchingSubscriptions: false,
        hasError: true,
      };

    case Action.Preferences.FetchEmailSubscriptionsCompleted:
      return {
        ...state,
        isFetchingSubscriptions: false,
        subscriptions: body.subscriptions || {},
        hasError: false,
      };

    default:
      return state;
  }
}
